import React from "react";
import FallbackImage from '../FallbackImage/FallbackImage';

const FeatureCard = ({ feature, customClassName = "" }) => {
  return (
    <div className={`bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 ${customClassName}`}>
      <div className="relative aspect-square overflow-hidden bg-[#F3F4F6]">
        <FallbackImage
          src={`/media/${feature.image}`}
          alt={feature.title}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          placeholderText={feature.title}
        />
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-bold text-heading mb-3">
          {feature.title}
        </h3>
        <p className="text-gray-600 leading-relaxed">
          {feature.description}
        </p>
      </div>
    </div>
  );
};

export default FeatureCard;
